import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  List,
  Modal,
  message,
  notification,
  Radio,
  Select,
  Skeleton,
  Switch,
  Tabs,
  Table,
  TimePicker,
} from 'antd';
import { EyeOutlined, UploadOutlined } from '@ant-design/icons';
import _ from 'lodash';
import Errors from 'validatorjs/src/errors';
import moment from 'moment';
import GoogleMapReact from 'google-map-react';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import styles from './styles.module.scss';
import whttp from '../../libs/whttp';
import { API_HOST, Role, GOOGLE_MAP_KEY } from '../../configs/env';
import AppHelper from 'libs/AppHelper';
import CitySelect from 'components/CitySelect/CitySelect';
import WUpload, { AvatarUpload } from 'components/WUpload/WUpload';
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert';
import { genFormItemAtrribute } from 'libs/FormHelper';
import brands from './brands.json';
import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton';

const Option = Select.Option;
const { TabPane } = Tabs;
const cardBodyStyle = { padding: 8, fontSize: 8 };
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };

@DragDropContext(HTML5Backend)
export default class StoreInfo extends Component {
  formRef = React.createRef();

  state = {
    storeInfo: {
      status: 1,
      name: null,
      account: null,
      type: 1,
      email: null,
      phone: null,
      tax_no: null,
      roles: [4],
      permissions: {},
      last_online_date: null,
      modified_date: null,
      modified_user_name: null,
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    is24: false,
    searchItem: '',
    checked: true,
    previewImage: null,
    banners: [],
  };

  componentDidMount() {
    AppHelper.updateConfig();
    this.fetchData();
  }

  fillData = (data) => {
    if (!this.formRef.current) return;

    if (data.mon_start && data.mon_end) {
      data.day1_1 = moment(_.get(data, 'mon_start'), 'HH:mm');
      data.day1_2 = moment(_.get(data, 'mon_end'), 'HH:mm');
    }
    if (data.tue_start && data.tue_end) {
      data.day2_1 = moment(_.get(data, 'tue_start'), 'HH:mm');
      data.day2_2 = moment(_.get(data, 'tue_end'), 'HH:mm');
    }
    if (data.wed_start && data.wed_end) {
      data.day3_1 = moment(_.get(data, 'wed_start'), 'HH:mm');
      data.day3_2 = moment(_.get(data, 'wed_end'), 'HH:mm');
    }
    if (data.thur_start && data.thur_end) {
      data.day4_1 = moment(_.get(data, 'thur_start'), 'HH:mm');
      data.day4_2 = moment(_.get(data, 'thur_end'), 'HH:mm');
    }
    if (data.fri_start && data.fri_end) {
      data.day5_1 = moment(_.get(data, 'fri_start'), 'HH:mm');
      data.day5_2 = moment(_.get(data, 'fri_end'), 'HH:mm');
    }
    if (data.sat_start && data.sat_end) {
      data.day6_1 = moment(_.get(data, 'sat_start'), 'HH:mm');
      data.day6_2 = moment(_.get(data, 'sat_end'), 'HH:mm');
    }
    if (data.sun_start && data.sun_end) {
      data.day7_1 = moment(_.get(data, 'sun_start'), 'HH:mm');
      data.day7_2 = moment(_.get(data, 'sun_end'), 'HH:mm');
    }
    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      };
    }

    data.deliveries = _.map(data.deliveries, (vendor) => ({
      ...vendor,
      image:
        _.get(vendor, 'icon_url') !== null
          ? {
              uid: 0,
              path: _.get(vendor, 'icon'),
              url: _.get(vendor, 'icon_url'),
            }
          : null,
    }));

    if (!_.isBoolean(data.status)) data.status = data.status === 1;
    if (!_.isBoolean(data.scango_flg)) data.scango_flg = data.scango_flg === 1;
    this.setState({ checked: data.scango_flg });
    _.map(data.images, (item, idx) => {
      if (item.path == null || item.url == null) {
        data.images.splice(idx, 1);
      }
    });
    this.setState({ is24: _.get(data, 'is24h') });
    this.formRef.current.setFieldsValue(data);
  };
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/mgt/v1/stores/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/stores');
        return;
      }

      this.fillData(data);
    });
  };

  submitData = (storeInfo = {}) => {
    if (_.get(storeInfo, 'day1_1'))
      storeInfo.mon_start = _.get(storeInfo, 'day1_1').format('HH:mm');
    if (_.get(storeInfo, 'day1_2'))
      storeInfo.mon_end = _.get(storeInfo, 'day1_2').format('HH:mm');
    if (_.get(storeInfo, 'day2_1'))
      storeInfo.tue_start = _.get(storeInfo, 'day2_1').format('HH:mm');
    if (_.get(storeInfo, 'day2_2'))
      storeInfo.tue_end = _.get(storeInfo, 'day2_2').format('HH:mm');
    if (_.get(storeInfo, 'day3_1'))
      storeInfo.wed_start = _.get(storeInfo, 'day3_1').format('HH:mm');
    if (_.get(storeInfo, 'day3_2'))
      storeInfo.wed_end = _.get(storeInfo, 'day3_2').format('HH:mm');
    if (_.get(storeInfo, 'day4_1'))
      storeInfo.thur_start = _.get(storeInfo, 'day4_1').format('HH:mm');
    if (_.get(storeInfo, 'day4_2'))
      storeInfo.thur_end = _.get(storeInfo, 'day4_2').format('HH:mm');
    if (_.get(storeInfo, 'day5_1'))
      storeInfo.fri_start = _.get(storeInfo, 'day5_1').format('HH:mm');
    if (_.get(storeInfo, 'day5_2'))
      storeInfo.fri_end = _.get(storeInfo, 'day5_2').format('HH:mm');
    if (_.get(storeInfo, 'day6_1'))
      storeInfo.sat_start = _.get(storeInfo, 'day6_1').format('HH:mm');
    if (_.get(storeInfo, 'day6_2'))
      storeInfo.sat_end = _.get(storeInfo, 'day6_2').format('HH:mm');
    if (_.get(storeInfo, 'day7_1'))
      storeInfo.sun_start = _.get(storeInfo, 'day7_1').format('HH:mm');
    if (_.get(storeInfo, 'day7_2'))
      storeInfo.sun_end = _.get(storeInfo, 'day7_2').format('HH:mm');
    storeInfo.is24h = _.get(this, 'state.is24');
    delete storeInfo.day1;
    delete storeInfo.day2;
    delete storeInfo.day3;
    delete storeInfo.day4;
    delete storeInfo.day5;
    delete storeInfo.day6;
    delete storeInfo.day7;

    storeInfo.city_id = _.get(storeInfo, 'address.city_id');
    storeInfo.area_id = _.get(storeInfo, 'address.area_id');
    storeInfo.street = _.get(storeInfo, 'street');
    storeInfo.status = _.get(storeInfo, 'status') ? 1 : 0;
    storeInfo.scango_flg = _.get(storeInfo, 'scango_flg') ? 1 : 2;
    //取得「英文資訊」頁籤資料
    storeInfo.en_bus_info = this.formRef.current.getFieldValue('en_bus_info');
    //storeInfo.en_business_hours = this.formRef.current.getFieldValue('en_business_hours')
    storeInfo.en_business_hours_special = this.formRef.current.getFieldValue(
      'en_business_hours_special'
    );
    storeInfo.en_name = this.formRef.current.getFieldValue('en_name');
    storeInfo.en_parking_info = this.formRef.current.getFieldValue(
      'en_parking_info'
    );
    storeInfo.en_street = this.formRef.current.getFieldValue('en_street');
    storeInfo.en_traffic_info = this.formRef.current.getFieldValue(
      'en_traffic_info'
    );
    //取得「店內服務」、「美食餐廳」、「專櫃介紹」頁籤資料
    storeInfo.service_ids = this.formRef.current.getFieldValue('service_ids');
    storeInfo.food_ids = this.formRef.current.getFieldValue('food_ids');
    storeInfo.common_ids = this.formRef.current.getFieldValue('common_ids');

    delete storeInfo['address'];

    storeInfo.deliveries = _.map(storeInfo.deliveries, (vendor) => ({
      ...vendor,
      icon: _.get(vendor, 'image.path'),
    }));
    // storeInfo.vip_store = _.map(storeInfo.vip_store, (vips) => ({
    //   id: vips.brand_id,
    //   is_vip: 1,
    // }));
    const current_user = _.get(window, 'VC_CONFIG.WP_CURRENT_USER', '');
    storeInfo.user_id = current_user.ID;
    const id = _.get(this, 'props.match.params.id', '');

    console.log('storeInfo', storeInfo);

    this.setState({ isSubmitData: true, messages: {} });
    whttp.post(
      API_HOST + `/api/mgt/v1/stores/${id}`,
      storeInfo,
      (state, res) => {
        this.setState({ isSubmitData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;
        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          notification['error']({
            message: '更新失敗',
            description: reason,
          });
          return this.setState({ messages: data.messages || {} });
        }

        const { data: { id: new_id } = {} } = res;
        if (new_id != id) {
          message.success('建立成功');
          this.setState({ storeInfo: data });
          return this.props.history.replace(`/stores/view/${new_id}`);
        }
        message.success('更新成功');
      }
    );
  };

  deleteUser = (e) => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isDeleteUser: true });
    whttp.delete(API_HOST + `/api/mgt/v1/stores/${id}`, {}, (state, res) => {
      this.setState({ isDeleteUser: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        return message.error(reason);
      }

      notification['success']({
        message: '刪除成功',
      });

      return this.props.history.replace(`/stores`);
    });
  };

  reloadMaps = () => {
    const { map, maps } = this.state;

    if (!maps || !map) return;

    if (Array.isArray(this.state.markers)) {
      this.state.markers.forEach((marker) => marker.setMap(null));
    }

    // zoom預設為能呈現出地形等高線的大小
    // 所以改成呈現最新的裝置位置
    let bounds = new maps.LatLngBounds();

    let stores = [
      {
        name: this.formRef.current.getFieldValue('name'),
        latitude: parseFloat(this.formRef.current.getFieldValue('latitude')),
        longitude: parseFloat(this.formRef.current.getFieldValue('longitude')),
      },
    ];

    const markers = stores.map((store, idx) => {
      const marker = new maps.Marker({
        map: map,
        position: { lat: store.latitude, lng: store.longitude },
        store: store,
      });

      let infowindow = new maps.InfoWindow({ content: store.name });

      marker.addListener('mouseover', function() {
        infowindow.open(map, marker);
      });

      marker.addListener('mouseout', function() {
        infowindow.close();
      });

      if (idx == 0) {
        bounds.extend(marker.getPosition());
      }
      return marker;
    });

    map.fitBounds(bounds);

    map.setZoom(16);

    this.setState({ markers });
  };

  enterNotSubmit = (e) => {
    if (e.key === 'Enter') {
      let value = e.target + '';
      if (value.indexOf('TextArea') !== -1) {
      } else e.preventDefault();
    }
  };

  handleFinishFailed = (errorInfo) => {
    if (errorInfo && errorInfo.errorFields) {
      const fieldNamesMap = {
        name: '分店中文名稱',
        full_name: '分店完整名稱',
        tax_id: '分店統一編號',
        scs_number_id: '詢問對象流水號',
        scs_number: '聯絡我們代碼',
        address: '地址',
        street: '地址',
      };

      const emptyFields = [];
      errorInfo.errorFields.forEach((field) => {
        const fieldKey = field.name[0];
        if (fieldNamesMap[fieldKey]) {
          if (!emptyFields.includes(fieldNamesMap[fieldKey])) {
            emptyFields.push(fieldNamesMap[fieldKey]);
          }
        } else if (fieldKey === 'deliveries') {
          if (!emptyFields.includes('第三方平台連結')) {
            emptyFields.push('第三方平台連結');
          }
        }
      });

      if (emptyFields.length > 0) {
        message.error(`[${emptyFields.join('、')} 為必填]`);
      }
    }
  };

  set24h = (value) => {
    this.formRef.current.setFieldsValue({
      day1_1: moment('00:00', 'HH:mm'),
      day1_2: moment('23:59', 'HH:mm'),
      day2_1: moment('00:00', 'HH:mm'),
      day2_2: moment('23:59', 'HH:mm'),
      day3_1: moment('00:00', 'HH:mm'),
      day3_2: moment('23:59', 'HH:mm'),
      day4_1: moment('00:00', 'HH:mm'),
      day4_2: moment('23:59', 'HH:mm'),
      day5_1: moment('00:00', 'HH:mm'),
      day5_2: moment('23:59', 'HH:mm'),
      day6_1: moment('00:00', 'HH:mm'),
      day6_2: moment('23:59', 'HH:mm'),
      day7_1: moment('00:00', 'HH:mm'),
      day7_2: moment('23:59', 'HH:mm'),
      is24h: value,
    });
    this.setState({ is24: value });
  };

  render() {
    const { storeInfo, messages, is24 } = this.state;
    const errors = _.get(this, 'state.validator.errors', new Errors());

    // 登入使用者的權限
    const editorPermissions = _.get(this.props, 'auth.permissions', {});
    const options = _.get(this, 'props.app.options', {});
    const privileges = _.get(window, 'VC_CONFIG.privileges');
    const id = parseInt(_.get(this, 'props.match.params.id'), 10);
    const isEdit = !isNaN(id);
    const storesModify = _.get(privileges, 'stores.modify', []);
    const canCreate = _.get(privileges, 'stores.create', false);
    const canEdit =
      _.indexOf(storesModify, 'all') !== -1 ||
      _.indexOf(storesModify, id) !== -1;
    const banners = this.formRef.current
      ? this.formRef.current.getFieldValue('banners')
      : [];

    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/stores`}>分店管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>分店資訊</Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          分店資訊
          <span />
        </h2>
        <ValidatorErrorAlert errors={errors} />
        <Skeleton loading={this.state.isFetchData}>
          <div className='block search'>
            <Form
              ref={this.formRef}
              name='basic'
              className='basicForm'
              layout='vertical'
              onFinish={(values) => this.submitData(values)}
              onFinishFailed={this.handleFinishFailed}
              onKeyDown={(e) => {
                this.enterNotSubmit(e)
              }}>
              {(canCreate || canEdit) && (
                <Form.Item
                  style={{ textAlign: 'right' }}
                  taillayout={{ wrapperCol: { offset: 8, span: 16 } }}>
                  <Button
                    type='primary'
                    htmlType='submit'
                    style={{ marginLeft: 8 }}
                    loading={this.state.isSubmitData}>
                    儲存
                  </Button>
                </Form.Item>
              )}
              <Tabs animated={false}>
                <TabPane tab='中文資訊' key='1'>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute('full_name', '分店完整名稱')}
                      rules={[
                        { required: true, message: '請輸入分店完整名稱' },
                      ]}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('tax_id', '分店統一編號')}
                      rules={[
                        { required: true, message: '請輸入分店統一編號' },
                      ]}>
                      <Input />
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute('name', '分店中文名稱')}
                      rules={[
                        { required: true, message: '請輸入分店中文名稱' },
                      ]}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute(
                        'scs_number_id',
                        '詢問對象流水號',
                      )}
                      rules={[
                        { required: true, message: '請選擇詢問對象流水號' },
                      ]}>
                      <Select>
                        {_.map(
                          _.get(options, 'store_scs_number_id', []),
                          (item) => (
                            <Option key={item.id} value={item.id}>
                              {item.name}
                            </Option>
                          ),
                        )}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute(
                        'scs_number',
                        '聯絡我們代碼請勿更動',
                      )}
                      rules={[{ required: true, message: '請輸入購物流水號' }]}>
                      <Input disabled={isEdit} />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('status', '狀態', 'checked')}>
                      <Switch checkedChildren='啟用' unCheckedChildren='停用' />
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item {...genFormItemAtrribute('code', '分店代號')}>
                      <Input />
                    </Form.Item>
                    <Form.Item {...genFormItemAtrribute('sn', '分店代碼')}>
                      <Input />
                    </Form.Item>
                    <Form.Item {...genFormItemAtrribute('sort', '排序')}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('scango_flg', 'Scan & go')}>
                      <Switch
                        unCheckedChildren='停用'
                        checkedChildren='啟用'
                        checked={this.state.checked}
                        onChange={(checked) =>
                          this.setState({ ...this.state, checked: checked })
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute(
                        'store_area_id',
                        '分店所在地區',
                      )}>
                      <Select>
                        {_.map(_.get(options, 'store_areas', []), (item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('store_group_id', '分店群組')}>
                      <Select>
                        {_.map(_.get(options, 'store_groups', []), (item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('store_type_id', '分店型態')}>
                      <Select>
                        {_.map(_.get(options, 'store_types', []), (item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item {...genFormItemAtrribute('fb', '臉書代碼')}>
                      <Input />
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute('contact_name', '連絡人')}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('contact_email', '連絡信箱')}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('contact_tel', '電話號碼')}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('contact_tel_ext', '分機號碼')}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('contact_fax', '傳真號碼')}>
                      <Input />
                    </Form.Item>
                  </div>
                  <Form.Item
                    {...genFormItemAtrribute('address', '地址')}
                    rules={[
                      { required: true, message: '請輸入地址' },
                    ]}>
                    <Input.Group compact>
                      <Form.Item
                        name='address'
                        noStyle
                        rules={[{ required: true, message: '請選擇縣市區域' }]}>
                        <CitySelect
                          placeholder='縣市區域'
                          style={{ width: '30%' }}
                        />
                      </Form.Item>
                      <Form.Item
                        name='street'
                        noStyle
                        rules={[
                          { required: true, message: '請輸入地址' },
                        ]}>
                        <Input
                          style={{ width: '70%' }}
                          placeholder='輸入地址'
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                  <div className='flexBox'>
                    <div>
                      <Form.Item
                        {...genFormItemAtrribute('store_link', '商家連結')}>
                        <Input style={{ width: '100%' }} />
                      </Form.Item>
                      <Form.Item
                        {...genFormItemAtrribute('latitude', 'GPS緯度')}>
                        <InputNumber style={{ width: '100%' }} />
                      </Form.Item>
                      <Form.Item
                        {...genFormItemAtrribute('longitude', 'GPS經度')}>
                        <InputNumber style={{ width: '100%' }} />
                      </Form.Item>
                    </div>
                    <div style={{ height: '40vh', width: '100%' }}>
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
                        defaultCenter={[25.0349656, 121.5444463]}
                        defaultZoom={13}
                        options={{ mapTypeControl: false }}
                        onGoogleApiLoaded={({ map, maps }) =>
                          this.setState({ map, maps }, () => this.reloadMaps())
                        }
                      />
                    </div>
                  </div>
                  <div className='flexBox'>
                    <div>
                      <div
                        style={{
                          paddingTop: '10px',
                          paddingBottom: '10px',
                        }}>
                        營業時間
                        <Checkbox
                          style={{ paddingLeft: '130px' }}
                          checked={this.state.is24}
                          onChange={(e) => {
                            this.set24h(e.target.checked)
                          }}>
                          24小時營業
                        </Checkbox>
                      </div>
                      <div className='flexBox'>
                        <div style={{ flex: 'none' }}>週一：</div>
                        <Form.Item name='day1_1'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                        <Form.Item name='day1_2'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                      </div>
                      <div className='flexBox'>
                        <div style={{ flex: 'none' }}>週二：</div>
                        <Form.Item name='day2_1'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                        <Form.Item name='day2_2'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                      </div>
                      <div className='flexBox'>
                        <div style={{ flex: 'none' }}>週三：</div>
                        <Form.Item name='day3_1'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                        <Form.Item name='day3_2'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                      </div>
                      <div className='flexBox'>
                        <div style={{ flex: 'none' }}>週四：</div>
                        <Form.Item name='day4_1'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                        <Form.Item name='day4_2'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                      </div>
                      <div className='flexBox'>
                        <div style={{ flex: 'none' }}>週五：</div>
                        <Form.Item name='day5_1'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                        <Form.Item name='day5_2'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                      </div>
                      <div className='flexBox'>
                        <div style={{ flex: 'none' }}>週六：</div>
                        <Form.Item name='day6_1'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                        <Form.Item name='day6_2'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                      </div>
                      <div className='flexBox'>
                        <div style={{ flex: 'none' }}>週日：</div>
                        <Form.Item name='day7_1'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                        <Form.Item name='day7_2'>
                          <TimePicker disabled={is24} format='HH:mm' />
                        </Form.Item>
                      </div>
                    </div>
                    <Form.Item
                      {...genFormItemAtrribute(
                        'business_hours_special',
                        '特殊營業時間',
                      )}>
                      <Input.TextArea rows={15} />
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute('parking_info', '停車收費方式')}>
                      <Input.TextArea rows={10} />
                    </Form.Item>
                    <div>
                      <div className='flexBox'>
                        <Form.Item
                          {...genFormItemAtrribute(
                            'parking_spaces_moto',
                            '機車車位數',
                          )}>
                          <InputNumber style={{ width: '100%' }} min={0} />
                        </Form.Item>
                        <Form.Item
                          {...genFormItemAtrribute(
                            'parking_spaces_car',
                            '汽車車位數',
                          )}>
                          <InputNumber style={{ width: '100%' }} min={0} />
                        </Form.Item>
                      </div>
                      <div className='flexBox'>
                        <Form.Item
                          {...genFormItemAtrribute(
                            'parking_spaces_handicapped',
                            '殘障車位數',
                          )}>
                          <InputNumber style={{ width: '100%' }} min={0} />
                        </Form.Item>
                        <Form.Item
                          {...genFormItemAtrribute(
                            'parking_spaces_parent',
                            '親子車位數',
                          )}>
                          <InputNumber style={{ width: '100%' }} min={0} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute('bus_info', '公車資訊')}>
                      <Input.TextArea rows={10} />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute('traffic_info', '其他交通資訊')}>
                      <Input.TextArea rows={10} />
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute('images', '樓層圖')}
                      valuePropName='fileList'
                      extra='第一張圖片請使用店外觀圖，建議解析度 寬1000x高500，最佳比例 2:1'>
                      <WUpload name='image' listType='picture('>
                        <Button>
                          <UploadOutlined /> 上傳 寬1000x高500，最佳比例 2:1
                        </Button>
                      </WUpload>
                    </Form.Item>
                  </div>
                  <div className='flexBox'>
                    <Form.Item>
                      <div className='flexBox'>
                        <Form.Item
                          {...genFormItemAtrribute('banners', '分店公告圖')}
                          valuePropName='fileList'
                          extra='寬530 x 高365 最佳比例 2:1'>
                          <WUpload
                            multiple={true}
                            showUploadList={false}
                            onChange={(fileList) => {
                              this.setState({ banners: fileList })
                            }}>
                            <Button>
                              <UploadOutlined /> 上傳
                            </Button>
                          </WUpload>
                        </Form.Item>
                      </div>
                      <Form.List name='banners'>
                        {(fields, { add, remove, move }) => (
                          <Table
                            dataSource={banners}
                            pagination={false}
                            rowKey='id'
                            components={{
                              body: {
                                row: DragableBodyRow,
                              },
                            }}
                            onRow={(record, index) => {
                              console.log('1', banners)
                              console.log('2', this.state.banners)

                              return {
                                index,
                                moveRow: (dragIndex, hoverIndex) => {
                                  move(dragIndex, hoverIndex)
                                  this.setState({ banners })
                                },
                              }
                            }}
                            columns={[
                              { dataIndex: 'id', title: '#' },
                              {
                                dataIndex: 'url',
                                title: '圖片',
                                render: (url) => (
                                  <div
                                    className='tableImg'
                                    style={{
                                      backgroundImage: `url(${url})`,
                                    }}
                                    alt='avatar'
                                  />
                                ),
                              },
                              {
                                dataIndex: 'link',
                                title: '分店公告圖URL',
                                render: (text, record, idx) => {
                                  return (
                                    <Form.Item
                                      {...genFormItemAtrribute([idx, 'link'])}>
                                      <Input />
                                    </Form.Item>
                                  )
                                },
                              },
                              {
                                dataIndex: 'id',
                                title: 'Action',
                                key: 'tools',
                                width: 250,
                                render: (id, record) => {
                                  return (
                                    <List
                                      grid={{ gutter: 4, column: 3 }}
                                      dataSource={[
                                        <DeleteConfirmButton
                                          size='small'
                                          onConfirm={() => {
                                            remove(banners.indexOf(record))
                                            this.setState({
                                              banners:
                                                this.state.banners.filter(
                                                  (b) => b.id !== record.id,
                                                ),
                                            })
                                          }}
                                        />,
                                        <Button
                                          type='default'
                                          size='small'
                                          icon={<EyeOutlined />}
                                          onClick={() =>
                                            this.setState({
                                              previewImage: {
                                                url: record.url,
                                              },
                                            })
                                          }>
                                          檢視
                                        </Button>,
                                      ]}
                                      renderItem={(item) => (
                                        <List.Item>{item}</List.Item>
                                      )}
                                    />
                                  )
                                },
                              },
                            ]}
                          />
                        )}
                      </Form.List>
                    </Form.Item>
                  </div>
                  <Divider>第三方平台</Divider>
                  <Form.List name='deliveries'>
                    {(fields, { add, remove, move }) => {
                      return (
                        <Fragment>
                          {fields.length > 0 && (
                            <Table
                              pagination={false}
                              rowKey={(item, idx) => idx}
                              dataSource={fields}
                              columns={[
                                {
                                  dataIndex: 'id',
                                  title: '#',
                                  render: (id, item, idx) => idx + 1,
                                },
                                {
                                  dataIndex: 'portion',
                                  title: '平台',
                                  render: (portion, item, idx) => (
                                    <Fragment>
                                      <Form.Item
                                        {...genFormItemAtrribute([
                                          idx,
                                          'vendor_id',
                                        ])}>
                                        <Select
                                          showSearch
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }>
                                          {_.map(
                                            _.get(options, 'vendors', []),
                                            (item) => (
                                              <Option
                                                key={item.id}
                                                value={item.id}>
                                                {item.name}
                                              </Option>
                                            ),
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </Fragment>
                                  ),
                                },
                                {
                                  dataIndex: 'portion',
                                  title: '品牌',
                                  render: (portion, item, idx) => (
                                    <Fragment>
                                      <Form.Item
                                        {...genFormItemAtrribute([
                                          idx,
                                          'brand_id',
                                        ])}>
                                        <Select
                                          showSearch
                                          filterOption={(input, option) =>
                                            option.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }>
                                          {_.map(
                                            _.get(options, 'brands', []),
                                            (item) => (
                                              <Option
                                                key={item.id}
                                                value={item.id}>
                                                {item.name}
                                              </Option>
                                            ),
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </Fragment>
                                  ),
                                },
                                {
                                  dataIndex: 'portion',
                                  title: '連結',
                                  render: (portion, item, idx) => (
                                    <Fragment>
                                      <Form.Item
                                        {...genFormItemAtrribute([idx, 'url'])}
                                        rules={[
                                          {
                                            required: true,
                                            message: '請填寫連結',
                                          },
                                          {
                                            type: 'url',
                                            message: '請填寫正確連結',
                                          },
                                        ]}>
                                        <Input />
                                      </Form.Item>
                                    </Fragment>
                                  ),
                                },
                                {
                                  dataIndex: 'name',
                                  title: 'Action',
                                  render: (name, item, idx) => (
                                    <Form.Item>
                                      <Button
                                        danger
                                        onClick={() => remove(idx)}>
                                        刪除
                                      </Button>
                                    </Form.Item>
                                  ),
                                },
                              ]}
                            />
                          )}
                          <Button onClick={() => add()}>新增</Button>
                        </Fragment>
                      )
                    }}
                  </Form.List>
                </TabPane>
                <TabPane tab='英文資訊' key='2'>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute('en_name', '分店英文名稱')}>
                      <Input />
                    </Form.Item>
                  </div>
                  <Form.Item label='英文地址'>
                    <Input.Group compact>
                      <Form.Item
                        noStyle
                        {...genFormItemAtrribute('address', '縣市區域')}>
                        <CitySelect
                          placeholder='縣市區域（英文）'
                          style={{ width: '30%' }}
                          language='en'
                        />
                      </Form.Item>
                      <Form.Item
                        noStyle
                        {...genFormItemAtrribute('en_street', '英文地址')}>
                        <Input style={{ width: '70%' }} />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute(
                        'en_business_hours_special',
                        '特殊營業時間(英文）',
                      )}>
                      <Input.TextArea rows={10} />
                    </Form.Item>
                  </div>
                  <Form.Item
                    {...genFormItemAtrribute(
                      'en_parking_info',
                      '停車收費方式(英文）',
                    )}>
                    <Input.TextArea rows={10} />
                  </Form.Item>
                  <div className='flexBox'>
                    <Form.Item
                      {...genFormItemAtrribute(
                        'en_bus_info',
                        '公車資訊(英文）',
                      )}>
                      <Input.TextArea rows={10} />
                    </Form.Item>
                    <Form.Item
                      {...genFormItemAtrribute(
                        'en_traffic_info',
                        '其他交通資訊(英文）',
                      )}>
                      <Input.TextArea rows={10} />
                    </Form.Item>
                  </div>
                </TabPane>
                {[
                  {
                    tabKey: 'services',
                    fieldName: 'service_ids',
                    optionKey: 'service_categories',
                    name: '店內服務',
                  },
                  {
                    tabKey: 'foods',
                    fieldName: 'food_ids',
                    optionKey: 'food_categories',
                    name: '美食餐廳',
                  },
                  {
                    tabKey: 'brands',
                    fieldName: 'common_ids',
                    optionKey: 'brand_categories',
                    name: '專櫃介紹',
                  },
                ].map((tabInfo) => (
                  <TabPane tab={tabInfo.name} key={tabInfo.tabKey}>
                    <Input
                      value={this.state.searchItem}
                      placeholder='input search text'
                      onChange={(e) => {
                        this.setState({ searchItem: e.target.value }, () => {
                          const value = this.formRef.current.getFieldValue(
                            tabInfo.fieldName,
                          )
                        })
                      }}
                      style={{ width: 200 }}
                    />
                    <Form.Item name={tabInfo.fieldName}>
                      <Checkbox.Group style={{ width: '100%' }}>
                        {_.map(
                          _.get(options, tabInfo.optionKey, []),
                          (categoryInfo) => {
                            if (
                              categoryInfo.items.filter((item) => {
                                if (
                                  item.name.length > 0 &&
                                  item.name.indexOf(this.state.searchItem) > -1
                                )
                                  return true
                                else return false
                              }).length > 0
                            )
                              return (
                                <Fragment>
                                  <Divider>{categoryInfo.name}</Divider>
                                  <List
                                    grid={listGrid}
                                    dataSource={categoryInfo.items.filter(
                                      (item) => {
                                        if (
                                          item.name.length > 0 &&
                                          item.name.indexOf(
                                            this.state.searchItem,
                                          ) > -1
                                        )
                                          return true
                                        else return false
                                      },
                                    )}
                                    renderItem={(item) => (
                                      <List.Item>
                                        <Card
                                          hoverable
                                          bodyStyle={cardBodyStyle}
                                          style={{ width: '100%' }}
                                          cover={
                                            <div
                                              className='aspect-fit'
                                              style={{
                                                backgroundImage: `url(${
                                                  item.image
                                                })`,
                                              }}
                                            />
                                          }
                                          onClick={() => {
                                            const value =
                                              this.formRef.current.getFieldValue(
                                                tabInfo.fieldName,
                                              )
                                            if (
                                              _.indexOf(value, item.id) === -1
                                            ) {
                                              value.push(item.id)
                                            } else {
                                              _.remove(
                                                value,
                                                (id) => id === item.id,
                                              )
                                            }
                                            this.formRef.current.setFields([
                                              {
                                                touched: true,
                                                validating: false,
                                                errors: [],
                                                name: [tabInfo.fieldName],
                                                value: value,
                                              },
                                            ])
                                          }}>
                                          <Card.Meta
                                            title={
                                              <Checkbox value={item.id}>
                                                {item.name}
                                              </Checkbox>
                                            }
                                          />
                                        </Card>
                                      </List.Item>
                                    )}
                                  />
                                </Fragment>
                              )
                          },
                        )}
                      </Checkbox.Group>
                    </Form.Item>
                  </TabPane>
                ))}
              </Tabs>
            </Form>
          </div>
          <Modal
            visible={this.state.previewImage}
            footer={null}
            onCancel={() => this.setState({ previewImage: null })}>
            <img
              alt='Preview'
              style={{ width: '100%' }}
              src={this.state.previewImage && this.state.previewImage.url}
            />
          </Modal>
        </Skeleton>
      </Layout>
    )
  }
}

let dragingIndex = -1;
class BodyRow extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: 'move' };

    let className = restProps.className;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...restProps} className={className} style={style} />
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, (connect) => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow)
);



// WEBPACK FOOTER //
// ./src/views/Store/StoreInfo.js